import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    semanticSgmRuns: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    crowdGroupId: null,
    semanticSgmRunId: null,
    semanticSgmDatasets: [],
    ssDsCount: 0,
    ssDsPage: 1,
    ssDsPageSize: 5,
    ssDsPages: 0,
    ssDsSortField: 'created_at',
    ssDsSortOrder: 'asc',
    ssDsSearch: null,
    ssDsError: '',
}

const receivedSSRunData=(state, action)=>{
    const { semanticSgmRuns,count,page,pageSize,pages,sortField,sortOrder,search,crowdGroupId } = action.data;
    return {
        ...state,
        semanticSgmRuns: semanticSgmRuns,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        crowdGroupId: crowdGroupId
    }
}

const getSSRunDataError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedSSDatasets=(state, action)=>{
    const { semanticSgmDatasets,semanticSgmRunId,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        semanticSgmRunId: semanticSgmRunId,
        semanticSgmDatasets: semanticSgmDatasets,
        ssDsCount: count,
        ssDsPage: page,
        ssDsPageSize: pageSize,
        ssDsPages: pages,
        ssDsSortField: sortField,
        ssDsSortOrder: sortOrder,
        ssDsSearch: search
    }
}

const getSSDatasetsDataError=(state, action)=> {
    return {
        ...state,
        ssDsError: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_SS_RUN_DATA]: receivedSSRunData,
    [actionTypes.GET_SS_RUN_DATA_ERROR]: getSSRunDataError,
    [actionTypes.GET_SS_DATASET_DATA]: receivedSSDatasets,
    [actionTypes.GET_SS_DATASET_DATA_ERROR]: getSSDatasetsDataError
});


// WEBPACK FOOTER //
// ./src/redux/semanticSgm/reducer.js